import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React from 'react';

export interface ISimpleMenuProps {
    children?: any;
    className?: string;
    mode: 'light' | 'dark';
    iconClass?: string;
    options: { label: string; callback: any }[] | undefined;
}

const ITEM_HEIGHT = 48;
const useStyles = makeStyles((theme: any) => ({
    icon: (props: any) => ({
        color: props.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
    }),
}));

export default function SimpleMenu({ children, className, iconClass, mode, options }: ISimpleMenuProps) {
    const classes = useStyles({ mode });
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    function handleClick(event: any) {
        setAnchorEl(event.currentTarget);
    }
    const handleMenuSelection = (event: any, callback: any) => {
        callback();
        handleClose();
    };

    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <div data-cy="SimpleMenu">
            <IconButton
                aria-controls="long-menu"
                aria-haspopup="true"
                aria-label="More"
                classes={{ root: classes.icon }}
                onClick={handleClick}
            >
                {children ? children : <MoreVertIcon />}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                className={className}
                data-cy="SimpleMenu-Menu"
                id="long-menu"
                keepMounted
                onClose={handleClose}
                open={open}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: 200,
                    },
                }}
            >
                {options &&
                    options.map((opt, idx) => (
                        <MenuItem key={idx} onClick={evt => handleMenuSelection(evt, opt.callback)}>
                            {opt.label}
                        </MenuItem>
                    ))}
            </Menu>
        </div>
    );
}
